<template>
    <option value="ground-truth">ground-truth</option>
    <option value="predictions">agrology-predictions</option>
    <option value="nasa">nasa</option>
    <option value="tomorrow-io">tomorrow-io</option>
</template>
